import { FC, SVGAttributes } from "react";

const PaypalIconBackground: FC<SVGAttributes<SVGSVGElement>> = ({
  width = 32,
  height = 24,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 34 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>PayPal</title>
    <path
      d="M4.7461 1.08655H29.2539C31.3175 1.08655 33 2.7976 33 4.92019V21.2529C33 23.3755 31.3175 25.0865 29.2539 25.0865H4.7461C2.68244 25.0865 1 23.3755 1 21.2529V4.92019C1 2.7976 2.68244 1.08655 4.7461 1.08655Z"
      fill="white"
      stroke="#EEEEEE"
    />
    <path
      d="M21.2424 9.87006C21.2317 9.94158 21.2194 10.0147 21.2055 10.0898C20.7305 12.6276 19.1054 13.5043 17.0299 13.5043H15.9732C15.7193 13.5043 15.5055 13.6961 15.4659 13.9566L14.9248 17.5273L14.7716 18.5394C14.7459 18.7104 14.8726 18.8647 15.0385 18.8647H16.9128C17.1348 18.8647 17.3233 18.6969 17.3582 18.4691L17.3767 18.37L17.7296 16.0396L17.7522 15.9118C17.7868 15.6832 17.9757 15.5154 18.1977 15.5154H18.478C20.2939 15.5154 21.7155 14.7482 22.131 12.5281C22.3046 11.6007 22.2147 10.8263 21.7554 10.2816C21.6164 10.1174 21.444 9.98114 21.2424 9.87006Z"
      fill="#99C6E5"
    />
    <path
      d="M20.7455 9.66387C20.6729 9.64189 20.5981 9.62191 20.5213 9.60393C20.4441 9.58635 20.365 9.57076 20.2836 9.55718C19.9986 9.50923 19.6864 9.48645 19.352 9.48645H16.5288C16.4593 9.48645 16.3933 9.50283 16.3341 9.5324C16.2039 9.59753 16.1072 9.7258 16.0838 9.88284L15.4832 13.8411L15.4659 13.9566C15.5055 13.6961 15.7193 13.5043 15.9732 13.5043H17.0299C19.1055 13.5043 20.7305 12.6272 21.2056 10.0898C21.2198 10.0147 21.2317 9.94158 21.2424 9.87005C21.1222 9.80372 20.992 9.74698 20.8519 9.69863C20.8173 9.68664 20.7816 9.67505 20.7455 9.66387Z"
      fill="#0071C0"
    />
    <path
      d="M16.0838 9.88286C16.1072 9.72582 16.204 9.59755 16.3341 9.53282C16.3937 9.50325 16.4593 9.48687 16.5288 9.48687H19.352C19.6865 9.48687 19.9987 9.50964 20.2836 9.55759C20.365 9.57118 20.4441 9.58676 20.5213 9.60435C20.5981 9.62233 20.673 9.64231 20.7455 9.66428C20.7816 9.67547 20.8173 9.68706 20.8523 9.69865C20.9924 9.747 21.1226 9.80414 21.2428 9.87007C21.3841 8.93225 21.2417 8.29371 20.7544 7.71551C20.2172 7.07897 19.2476 6.80646 18.0068 6.80646H14.4049C14.1515 6.80646 13.9353 6.99826 13.8961 7.25919L12.3958 17.1549C12.3663 17.3507 12.5114 17.5273 12.7011 17.5273H14.9249L15.4832 13.8411L16.0838 9.88286Z"
      fill="#0071C0"
    />
  </svg>
);

export default PaypalIconBackground;
